import * as _ from "lodash";
import * as commonData from "../../../webapp-commons/data";

export const DEFAULT_HOST_FILTERS_SETTINGS = {
  view: 1,
  search: "",
  filters: ["available"]
};

export const DEFAULT_PROJECT_FILTERS_SETTINGS = {
  search: "",
  filter: "active",
  column: "all",
  year: new Date().getFullYear()
};

export const DEFAULT_PROSPECTS_FILTERS_SETTINGS = {
  search: "",
  column: "all",
  filter: "active"
};

export const PROGRESS_ORDER = [...commonData.PROGRESS_ORDER];

export const SERVICES = [...commonData.SERVICES];

export const ROLES = {
  USER: "USER",
  OPERATOR: "OPERATOR",
  VENDOR: "VENDOR",
  SALE: "SALE",
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPERADMIN"
};

export const ROLES_TO_TEXT = [
  { value: ROLES.USER, text: "Utilisateur" },
  { value: ROLES.OPERATOR, text: "Consultant·e" },
  { value: ROLES.SALE, text: "Commercial" },
  { value: ROLES.ADMIN, text: "Admin" },
  { value: ROLES.SUPERADMIN, text: "Superadmin" }
];

export const FOLDER_STATUS = [
  { value: "submitted", text: "Déposé" },
  { value: "accepted", text: "Accepté" },
  { value: "rejected", text: "Rejeté", disabled: true },
  { value: "rejected_agency", text: "Rejeté par l'agence" },
  { value: "rejected_customer", text: "Rejeté par le client" },
  { value: "unknown", text: "Inconnu" }
];

export const PROJECT_STATUS = [...commonData.PROJECT_STATUS];
export const DOCUMENT_TYPES = [...commonData.DOCUMENT_TYPES];

export const COLUMNS_NAMES = {
  all: "Toutes",
  projectCreated: "Nouveaux inscrits",
  toCall: "A rappeler",
  eligibility: "Dossier en attente",
  docsMobiPass: "Dossier en cours",
  toAssign: "A répartir",
  docsLease: "Dossier en cours de finalisation",
  researchStarted: "Recherche démarrée",
  visitScheduled: "Proposition visite",
  caseAccepted: "Dossier accepté/Bail en cours",
  leaseFetched: "Bail signé",
  awaitingSignature: "Signature MP et CR en cours",
  signed: "Constitution dossier final",
  submittedToHil: "Soumis à HiL",
  sentToAL: "Envoyé à AL",
  relanceAL: "Relancé à AL",
  paid: "Payé"
};

export const ALL_COLUMNS = [
  { text: "Toutes", value: "all", isAgregate: true },
  { text: "Nouveaux inscrits", value: "projectCreated" },
  { text: "A rappeler", value: "toCall" },
  { text: "Dossier en attente", value: "eligibility" },
  { text: "Dossier en cours", value: "docsMobiPass" },
  { text: "A répartir", value: "toAssign" },
  { text: "Dossier en cours de finalisation", value: "docsLease" },
  { text: "Recherche démarrée", value: "researchStarted" },
  { text: "Proposition visite", value: "visitScheduled" },
  { text: "Dossier accepté/Bail en cours", value: "caseAccepted" },
  { text: "Bail signé", value: "leaseFetched" },
  { text: "Signature MP et CR en cours", value: "awaitingSignature" },
  { text: "Constitution dossier final", value: "signed" },
  { text: "Soumis à HiL", value: "submittedToHil" },
  { text: "Envoyé à AL", value: "sentToAL" },
  { text: "Relance", value: "relanceAL", adminOnly: true },
  { text: "Payé", value: "paid", superAdminOnly: true }
];

export const PROJECTS_COLUMNS_NAMES = ALL_COLUMNS.reduce(
  (acc, { text, value }, i) => {
    acc[value] = `[${i + 1}] ` + text;
    return acc;
  },
  {}
);

export const ALL_PROSPECTS_COLUMNS = [
  { text: "Toutes", value: "all", isAgregate: true },
  { text: "Nouveaux prospects", value: "new" },
  { text: "Prospects", value: "toCall" },
  { text: "1er contact établi", value: "firstContact" },
  { text: "Démo HiL", value: "pitched" },
  {
    text: "Intéressé",
    description: "Inscription processus",
    value: "involved"
  },
  { text: "Bêta testeur", description: "1 client à reloger", value: "testing" },
  { text: "Partenariat conclu", value: "done" }
];

export const PROSPECT_ORDER = _(ALL_PROSPECTS_COLUMNS)
  .reject({ isAgregate: true })
  .map("value")
  .value();

export const ALL_ANNOUNCEMENTS_COLUMNS = [
  { text: "Prospect", value: "prospect" },
  { text: "A rappeler", value: "toCallback" },
  { text: "En réflexion", value: "waiting" },
  { text: "Projet", value: "ok" },
  { text: "Abandonné", value: "stopped" }
];

export const ANNOUNCEMENTS_COLUMNS_NAMES = ALL_ANNOUNCEMENTS_COLUMNS.reduce(
  (acc, { text, value }, i) => {
    acc[value] = `[${i + 1}] ` + text;
    return acc;
  },
  {}
);

const phoneRegex = /^\+?\d{10,}$/;

export const PROJECT_TO_ASSIGN_VALIDATION = {
  firstName: "required",
  lastName: "required",
  phoneNumber: {
    required: true,
    regex: phoneRegex
  },
  civility: "required",
  addressWork: "required|precise:addressWorkObject",
  actualCity: "required|precise:fromAddressObject",
  contractType: "required",
  company: "required",
  companySiret: "required|length:14",
  job: "required",
  contractStartDate: "required",
  aboutYouAdmin: "required",
  companyContactName: "required",
  companyPhone: {
    required: true,
    regex: phoneRegex
  },
  companyMail: "required|email",
  coFirstName: "required_if:coEnabled,true",
  coLastName: "required_if:coEnabled,true",
  coEmail: "required_if:coEnabled,true|email",
  coPhoneNumber: {
    required_if: "coEnabled,true",
    regex: phoneRegex
  },
  coCivility: "required_if:coEnabled,true",
  coAddress: "required_if:coEnabled,true",
  sponsor: "required"
};

export const PROJECT_DOCS_LEASE_VALIDATION = {
  ...PROJECT_TO_ASSIGN_VALIDATION,
  typeOfEstate: "required",
  surfacemin: "required|min_value:1",
  numberOfRoom: "required|min_value:1",
  budget: "required|min_value:0",
  dateMove: "required",
  criterion1: "required",
  criterion2: "required",
  criterion3: "required",
  zone: "required",
  nationality: "required",
  familyStatus: "required",
  childrenCount: "required|min_value:0",
  childrenToBeBorn: "min_value:0",
  wage: "required|min_value:0",
  otherIncomes: "min_value:0",
  referenceTaxRevenue: "min_value:0",
  previousOwnerType: "required",
  customerSituation: "required",
  descEstateAdmin: "required",
  futurNeighborhoodAdmin: "required"
};

export const PROJECT_LEASE_FETCHED_VALIDATION = {
  ...PROJECT_DOCS_LEASE_VALIDATION,
  leaseSignDate: "date",
  chosenEstate: "required"
};

export const PROJECT_VALIDATION = {
  ...PROJECT_LEASE_FETCHED_VALIDATION,
  dateOfBirth: "required",
  placeOfBirth: "required",
  deptOfBirth: "required",
  coDateOfBirth: "required_if:coEnabled,true",
  coDeptOfBirth: "required_if:coEnabled,true",
  coPlaceOfBirth: "required_if:coEnabled,true"
};

export const PROSPECT_VALIDATION = {};

export const VISIT_AUTHORS = [
  { value: "submitted", text: "A définir", disabled: true },
  { value: "customer", text: "Client·e" },
  { value: "operator", text: "Consultant·e" },
  { value: "sale", text: "Commercial·e" },
  { value: "other", text: "Autre" }
];

export const ABORT_MOTIVATIONS = [
  "Peut chercher seul",
  "Ne peut pas financer",
  "Solution alternative (sous location, hébergé, ...)",
  "Intéressé uniquement par les aides financières",
  "Projet pas en adéquation avec le marché (budget/critères)",
  "A déjà trouvé un logement ou ne recherche plus",
  "Ne répond plus",
  "Non éligible (- de 10 personnes)",
  "Non éligible (- de 1h15 ou 70km)",
  "Non éligible (pas de contrat de travail)",
  "Non éligible (recherche sur le lieu de l’école et non le lieu de l’alternance)",
  "Non éligible (en dehors des délais d'Action Logement)",
  "Autre prestataire",
  "Ne déménage plus"
];
